import { EventData } from './event-data';
import { Socket } from './socket';

/**
 * Represente un évènement de workflow.
 */
export class Event {
    /**
     *
     * @param id : Id de l'évènement.
     * @param triggerId : Id du trigger qui déclenche l'évènement.
     * @param actionId : Id de l'action executée par l'évènement.
     * @param triggerSocket : Socket du trigger utilisée par l'évènement.
     * @param actionSocket : Socket de l'action utilisée par l'évènement.
     * @param data : Données de l'évènement.
     */
    public constructor(
        public id: number,
        public triggerId: number,
        public actionId: number,
        public triggerSocket: Socket,
        public actionSocket: Socket,
        public data: EventData
    ) {}

    /**
     * Retourne une copie d'une instance d'Event
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: Event) {
        if (!!other) {
            const instance = new Event(other.id, other.triggerId, other.actionId, Socket.clone(other.triggerSocket), Socket.clone(other.actionSocket), other.data);
            instance.id = other.id;
            instance.data.id = instance.id;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances d'Event
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: Event[]) {
        if (!!others) {
            let events: Event[] = [];

            others.forEach((x) => {
                const event = Event.clone(x);
                events.push(event);
            });

            return events;
        } else {
            return [];
        }
    }
}
